var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeepLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2063_2305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20V20.0004H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2063_2305)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "parent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.112 2.21673V2.22228H4.43513C3.22065 2.22228 2.22173 3.21898 2.22173 4.43901V15.5615C2.22173 16.7838 3.21621 17.7783 4.43846 17.7783H15.561C16.7832 17.7783 17.7777 16.7827 17.7777 15.556V11.0859C17.7922 10.4847 18.2844 10.0003 18.8889 10.0003C19.4944 10.0003 19.9867 10.4847 20 11.0859V15.556C20 18.0105 18.0088 20.0006 15.561 20.0006H4.43846C1.98728 20.0006 -0.000549316 18.0094 -0.000549316 15.5615V4.43901C-0.000549316 1.98783 1.99728 0 4.43513 0H10.112V0.00555571C10.6731 0.0611128 11.1109 0.53557 11.1109 1.11114C11.1109 1.68782 10.6731 2.16117 10.112 2.21673Z",
    fill: "#594AD7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "parent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9385 5.95144C13.3207 5.5692 13.9352 5.56365 14.3185 5.94699C14.6974 6.32589 14.7041 6.93591 14.313 7.32592L11.5062 10.1338C11.124 10.5149 10.5095 10.5205 10.1273 10.1382C9.74727 9.75821 9.74061 9.14819 10.1317 8.75818L12.9385 5.95144Z",
    fill: "#F22B5D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "parent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6709 10.0951L14.2964 8.71947L17.7799 5.23604C18.0988 4.91715 17.9188 3.9649 17.1098 3.15599C16.3065 2.35374 15.3465 2.16929 15.0342 2.48152L11.5464 5.97051L10.1719 4.59491L13.6586 1.10704C14.8898 -0.122995 17.0343 0.285905 18.5077 1.75928C19.9866 3.23932 20.3899 5.37605 19.1555 6.61053L15.6709 10.0951Z",
    fill: "#F22B5D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "parent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8962 10.1187L14.2707 11.4943L10.7873 14.9788C9.55279 16.2133 7.41496 15.81 5.93603 14.3299C4.46265 12.8566 4.05264 10.7132 5.28379 9.48202L8.77166 5.99414L10.1461 7.36862L6.65827 10.8565C6.34604 11.1687 6.52938 12.1299 7.33273 12.9321C8.14164 13.741 9.09389 13.921 9.41279 13.6021L12.8962 10.1187Z",
    fill: "#F22B5D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepLink);
export default __webpack_public_path__ + "static/media/deepLink.abe575827f6f0780582c3842b890da54.svg";
export { ForwardRef as ReactComponent };